// src/context/AuthContext.js
import React, { createContext, useState, useContext } from 'react';
import axios from 'axios';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [username, setUsername] = useState('');
  const [projects, setProjects] = useState([]);

  const login = async (username, token) => {
    setIsAuthenticated(true);
    setUsername(username);

    try {
      const response = await axios.get('${config.apiBaseUrl}/api/projects', {
        headers: {
          'Authorization': `Bearer ${token}`,
          'X-TenantID': 'admin',
        },
      });
      setProjects(response.data);
    } catch (error) {
      console.error('Error fetching projects:', error);
    }
  };

  const logout = () => {
    setIsAuthenticated(false);
    setUsername('');
    setProjects([]);
  };

  return (
    <AuthContext.Provider value={{ isAuthenticated, username, projects, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);